export default {
  mounted(el, binding) {
    if (!binding.value || typeof binding.value !== 'function') {
      console.warn('v-on-resize directive requires a function value');
      return;
    }

    const observer = new ResizeObserver(entries => {
      binding.value(entries[0]);
    });

    observer.observe(el);

    // Store the observer on the element for cleanup
    el._resizeObserver = observer;
  },

  unmounted(el) {
    if (el._resizeObserver) {
      el._resizeObserver.disconnect();
      delete el._resizeObserver;
    }
  }
}; 